module.exports = __webpack_public_path__ + "static/media/p_22_0.50a6ca12.png";